export function parseServiceResult(value) {
    try {
        const result = typeof value === 'string' ? JSON.parse(value) : value;
        return result?.type === 'rsv_service_data' && Array.isArray(result.data) ? result : null;
    } catch { return null; }
}

export function upsertServiceResult(results, result) {
    const key = value => `${value.query_type}:${value.city || ''}:${value.district || ''}`;
    return [...results.filter(value => key(value) !== key(result)), result];
}

export function serviceLocationTool(tool, message) {
    if (tool?.name === 'request_device_location') return tool;
    if (tool?.name !== 'query_rsv_service_data') return null;
    let args = tool.arguments;
    try { if (typeof args === 'string') args = JSON.parse(args); } catch { return null; }
    if (!['facility', 'pilot_status'].includes(args?.query_type)) return null;
    if ((args.city || args.district) && !/附近|身边|周边|就近|最近|离我/.test(message)) return null;
    return {name: 'request_device_location', arguments: {vaccine_type: 'RSV', query_type: args.query_type}};
}

export function messageServiceResults(message) {
    let results = message.serviceResults || [];
    for (const call of message.toolCalls || []) {
        const result = parseServiceResult(call.toolOutput);
        if (result) results = upsertServiceResult(results, result);
    }
    // A device-based card supersedes an unlocated registry slice from old servers.
    return message.clinicRecommendation ? results.filter(result => !['facility', 'pilot_status'].includes(result.query_type)) : results;
}

// 定位结果与正文共享同一数据源，不能让未获得定位的模型推荐另一城市。
export function locatedServiceReply(result) {
    if (!result) return '';
    if (result.status === 'locating') return '正在根据您的设备位置查询附近登记机构，请稍候。';
    const clinics = result.clinics || [];
    if (result.status !== 'ok' || !clinics.length) {
        return `${result.message || '暂时未能查到您附近的登记机构，请稍后重试。'}\n无法据此确认附近机构，请勿将其他地区的名单作为就近推荐。`;
    }
    const names = clinics.map(clinic => clinic.name || clinic.facility_name).filter(Boolean).slice(0, 3);
    return `${result.message || '已根据您的设备位置查询附近登记机构。'}${names.length ? `\n\n可查看：${names.join('、')}。具体地址、距离和联系方式见下方卡片。` : ''}\n\n登记信息不代表实时库存或一定可预约，前往前请向机构确认是否提供所需服务及适用条件。`;
}
